import React, {useEffect, useState} from "react";
import AxiosServices from "../Services/axiosServices";
import {IMatchDays} from "../Interfaces/IMatchDays";
import {Segmented, Switch, Tag, Tooltip} from "antd";
import "./MatchDays.css"
import {IMatch} from "../Interfaces/IMatch";
import {IGrpCmpEdt} from "../Interfaces/IGrpCmpEdt";
import {contrastColor} from "../Services/color";
import {useGlobal} from "../config/GlobalContext";

const MatchDays = () => {

    const [matchDays, setMatchDays] = useState<IMatchDays[]>([]);
    const [value, setValue] = useState<string | number>('*');
    const [selectedMatchDays, setSelectedMatchDays] = useState<string[]>([]);
    const {filteredMatches, setFilteredMatches, currentCmpEdt, groups, hasGroups, selectedGroupIds, setSelectedGroupIds} = useGlobal();

    useEffect(() => {
        // Réinitialiser le filtre quand la compétition change
        setValue('*');
        setSelectedMatchDays([]);
        setFilteredMatches("");

        AxiosServices.getMatchDays(setMatchDays, currentCmpEdt)
            .then()
            .catch(err => console.error(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCmpEdt]);

    const handleSegmentedChange = (val: string | number) => {
        setValue(val);
        if (val === '*') {
            setSelectedMatchDays([]);
            setFilteredMatches("");
        } else {
            const selectedDay = matchDays.find(day => day.Lib === val);
            if (selectedDay) {
                const matchDayLibs = selectedDay.MatchDay.map(md => md.Lib);
                setSelectedMatchDays(matchDayLibs);
                filterMatches(matchDayLibs);
                if (matchDayLibs.length > 0) {
                    setFilteredMatches(matchDayLibs[0]);
                }
            } else {
                setSelectedMatchDays([]);
                setFilteredMatches("");
            }
        }
    }

    const handleSubSegmentedChange = (val: string | number) => {
        const s = val.toString();
        setFilteredMatches(s === '*' ? '' : s);
    }

    const filterMatches = (matchDayLibs: string[]) => {
        AxiosServices.getMatches((matches: IMatch[]) => {
            const filtered = matches.filter(match => matchDayLibs.includes(match.Journee_Lib));
            if (filtered.length > 0)
                setFilteredMatches(filtered[0]?.Journee_Lib);
        }, currentCmpEdt)
            .then()
            .catch(err => console.error(err));
    }

    const matchDaysLibArray = matchDays.map(day => day.Lib);
    matchDaysLibArray.unshift('*');

    const segmentedStyle = {
        backgroundColor: '#203923',
        color: 'wheat',
        borderColor: 'wheat',
        itemSelectedBg: 'wheat',
        itemSelectedColor: 'red',
    };

    const toggleGroup = (id: number) => {
        setSelectedGroupIds(
            selectedGroupIds.includes(id)
                ? selectedGroupIds.filter(g => g !== id)
                : [...selectedGroupIds, id]
        );
    };

    return (
        <div className={"matchdays"}>
            <div className="matchdays-left">
                {hasGroups && groups.length > 0 && (() => {
                    const allSelected = groups.every(g => selectedGroupIds.includes(g.Idt));
                    return (
                    <div className="matchdays-groups">
                        {groups.map((group: IGrpCmpEdt) => {
                            const active = selectedGroupIds.includes(group.Idt);
                            const letter = (group.Grp_Cod ?? group.lib ?? '').slice(0, 1).toUpperCase();
                            return (
                                <Tag
                                    key={group.Idt}
                                    onClick={() => toggleGroup(group.Idt)}
                                    title={group.lib}
                                    style={{
                                        cursor: 'pointer',
                                        borderColor: group.clr,
                                        color: active ? contrastColor(group.clr) : group.clr,
                                        background: active ? group.clr : 'transparent',
                                        fontWeight: 600,
                                        minWidth: 22,
                                        textAlign: 'center',
                                        padding: '0 6px',
                                        userSelect: 'none',
                                        transition: 'all 0.2s',
                                        margin: 0,
                                    }}
                                >
                                    {letter}
                                </Tag>
                            );
                        })}
                        <Tooltip
                            title={allSelected ? "Tout désélectionner" : "Tout sélectionner"}
                        >
                            <Switch
                                size="small"
                                checked={allSelected}
                                onChange={(checked) => {
                                    if (checked) setSelectedGroupIds(groups.map(g => g.Idt));
                                    else setSelectedGroupIds([]);
                                }}
                            />
                        </Tooltip>
                    </div>
                    );
                })()}
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'small'}}>
                <Segmented
                    options={matchDaysLibArray}
                    value={value}
                    onChange={handleSegmentedChange}
                    style={segmentedStyle}
                />
                <Segmented
                    options={selectedMatchDays.length > 0 ? ['*', ...selectedMatchDays] : []}
                    style={segmentedStyle}
                    value={filteredMatches || '*'}
                    onChange={handleSubSegmentedChange}
                />
            </div>
        </div>
    );
}

export default MatchDays;
